import { Box, IconButton, Radio, makeStyles } from "@material-ui/core";
import { EditIcon, DeleteIcon } from "../../../../icons";
import { GroupBase, OptionProps, components } from "react-select5";

export function RadioOptionComponent<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>({
  ...props
}: OptionProps<Option, IsMulti, Group> & {
  onEdit?: (option: Option) => void;
  onDelete?: (option: Option) => void;
}) {
  const classes = useStyles();
  const { children, onDelete, onEdit, ...rest } = props;

  if (!children) return;

  const _onEdit = (option: Option, event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();
    if (onEdit) onEdit(option);
  };

  const _onDelete = (option: Option, event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();
    if (onDelete) onDelete(option);
  };

  return (
    <components.Option {...rest}>
      <span className={classes.root}>
        <Box>
          <Radio
            checked={props.isSelected}
            style={{ padding: "0rem", marginRight: "0.5rem" }}
          />
          {props.children}
        </Box>
        {(onEdit || onDelete) && (
          <Box className={classes.iconContainer}>
            {onEdit && (
              <IconButton
                onClick={(e) => _onEdit(rest.data, e)}
                className={classes.iconButton}
              >
                <EditIcon className={classes.icon} />
              </IconButton>
            )}
            {onDelete && (
              <IconButton
                onClick={(e) => _onDelete(rest.data, e)}
                className={classes.iconButton}
              >
                <DeleteIcon className={classes.icon} />
              </IconButton>
            )}
          </Box>
        )}
      </span>
    </components.Option>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "0.5rem",
    // wordBreak: "break-word"
    whiteSpace: "nowrap"
  },
  iconButton: {
    padding: "0.25rem",
    zIndex: 9999
  },
  iconContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "0rem"
  },
  icon: {
    color: theme.palette.primary.main,
    width: "1.5rem",
    height: "1.5rem",
    "&:hover": {
      cursor: "pointer"
    },
    zIndex: 1000
  }
}));
